/**
 * Lenis smooth scroll — Virtual Wall of Hope only.
 * Synced with GSAP ScrollTrigger. Skipped for reduced motion.
 */

export default function initLenis() {
	// Site-wide pages keep native scroll; Lenis only on the wall.
	if ( ! document.querySelector( '.bts-hope-board.is-opposite-slide-fixed' ) ) {
		return null;
	}

	if ( typeof window.Lenis === 'undefined' ) {
		return null;
	}

	if ( typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' ) {
		return null;
	}

	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return null;
	}

	// Avoid double-init (Elementor / re-entry).
	if ( window.btsLenis ) {
		return window.btsLenis;
	}

	gsap.registerPlugin( ScrollTrigger );

	const lenis = new window.Lenis( {
		duration: 1.1,
		easing: ( t ) => Math.min( 1, 1.001 - Math.pow( 2, -10 * t ) ),
		smoothWheel: true,
		touchMultiplier: 1.5,
	} );

	lenis.on( 'scroll', ScrollTrigger.update );

	gsap.ticker.add( ( time ) => {
		lenis.raf( time * 1000 );
	} );
	gsap.ticker.lagSmoothing( 0 );

	window.btsLenis = lenis;

	// Pause page smooth scroll while Magnific is open (keeps background locked).
	// Mark the wrap so wheel/touch still scrolls popup content (data-lenis-prevent).
	if ( typeof window.jQuery !== 'undefined' ) {
		window.jQuery( document )
			.on( 'mfpOpen.btsLenis', () => {
				lenis.stop();
				const wrap = document.querySelector( '.mfp-wrap' );
				if ( wrap ) {
					wrap.setAttribute( 'data-lenis-prevent', '' );
				}
			} )
			.on( 'mfpClose.btsLenis', () => {
				lenis.start();
				ScrollTrigger.refresh();
			} );
	}

	return lenis;
}
